import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  privacy: string;

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.privacy = await this.getAdmin();
  }

  //개인정보 이용약관 불러오기
  getAdmin(): Promise<any> {
    return this.db
      .doc$(`master/maumMaster`)
      .pipe(
        map(data => {
          return data.privacy;
        })
      )
      .pipe(first())
      .toPromise();
  }
}
